import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routing from './Routing';


ReactDOM.render(
    <Routing />,
    document.getElementById('root')
);